import { showToast } from "src/app/methods/showToast";
import {
  MAX_SIZE_SINGLE_ATTACHMENT,
  getMetaFileParams,
} from "src/utils/uploadFunctionsUtils";
import { uuidv7 as uuid } from "uuidv7";
import { UploadMultiFilesExt } from "./uploadMultiFilesExt";

export const uploadExternalFile = async (
  e,
  fieldId,
  metafieldUuid,
  metaFieldType,
  taskType,
  taskId,
  wsWorkspaceUuid,
  token,
  setFilesData,
  extensionUuid,
  formType,
  useTemporaryUpload = false,
) => {
  const { target } = e;
  const { files } = target;

  const newFiles = Array.from(files).map((item) => ({
    assetId: uuid(),
    mimeType: item.type,
    publicPreviewUrl: "",
    publicDownloadUrl: "",
    name: item.name,
    loading: true,
    new: true,
    size: item.size,
  }));

  return uploadMultipleFiles(
    e,
    fieldId,
    metafieldUuid,
    metaFieldType,
    taskType,
    taskId,
    () => {
      setFilesData((p) => {
        const prevFiles = Array.isArray(p) ? p : [];
        return [...prevFiles, ...newFiles];
      });
    },
    () => {
      setFilesData((p) => {
        const prevFiles = Array.isArray(p) ? p : [];
        return prevFiles.map((f) => {
          return { ...f, loading: false };
        });
      });
    },
    wsWorkspaceUuid,
    token,
    newFiles,
    extensionUuid,
    formType,
    setFilesData,
    useTemporaryUpload,
  );
};

export const uploadMultipleFiles = async (
  e,
  fieldId,
  wsMetaFieldUuid,
  wsMetaFieldType,
  taskType,
  wsTaskUuid,
  beforeCallback,
  thenCallback,
  wsWorkspaceUuid,
  token,
  newFiles,
  extensionUuid,
  formType,
  setFilesData,
  useTemporaryUpload = false,
) => {
  const { files } = e.target;

  if (!files?.length) return;

  const allowedTypes = [
    "png",
    "jpg",
    "jpeg",
    "pdf",
    "xls",
    "xlsx",
    "doc",
    "docx",
    "pptx",
    "ppt",
    "txt",
    "zip",
    "mp3",
    "mp4",
    "avi",
    "webm",
    "mov",
    "csv",
    "odt",
    "ods",
  ];

  const isTask = wsTaskUuid;
  const { url, parentType } = getMetaFileParams(isTask);

  const uploadFiles = new UploadMultiFilesExt(
    files,
    allowedTypes,
    MAX_SIZE_SINGLE_ATTACHMENT,
    fieldId,
    wsMetaFieldUuid,
    wsMetaFieldType,
    parentType,
    taskType,
    wsTaskUuid,
    wsWorkspaceUuid,
    token,
    newFiles,
    extensionUuid,
  );

  try {
    uploadFiles.validate();
    if (beforeCallback) beforeCallback();

    if (useTemporaryUpload) {
      // Use temporary file upload for fields without uuid
      const uploadedFiles = await uploadFiles.sendAllRequestsForTemporaryFile();

      // Update files data with key information
      setFilesData((prevFiles) => {
        const prevFilesArray = Array.isArray(prevFiles) ? prevFiles : [];

        // Find files that are currently loading and match them with uploaded files
        let uploadedIndex = 0;
        return prevFilesArray.map((file) => {
          if (file.loading && uploadedFiles[uploadedIndex]) {
            const uploadedFile = uploadedFiles[uploadedIndex];
            uploadedIndex++;
            return {
              ...file,
              key: uploadedFile.key,
              fileName: uploadedFile.fileName,
              loading: false,
            };
          }
          return file;
        });
      });

      return uploadedFiles;
    }

    if (formType === "recruitmentForm") {
      return await uploadFiles.sendAllRequestsForRecruitmentFormField();
    }
    await uploadFiles.sendAllRequestsForExternalTaskField();

    if (thenCallback) thenCallback();
  } catch (err) {
    console.error(err);
    if (!uploadFiles.hasCorrectType || !uploadFiles.hasCorrectSize) {
      showToast("error", "Error", err.message);
    } else {
      showToast("error", "Error", "An error occurred during uploading files.");
    }
  }
};
